import { ViewType } from '../contract_tabs/NewContractAnalytics'
import Tile from '../layout/Tile'
import { snackbar } from '../services/SnackbarService'
import ExpenseByTosSection from './ExpenseByTosSection'
import TotalExpenseByTosSection from './TotalExpenseByTosSection'
interface P {
    contractId: number
    filterStartDate?: string
    filterEndDate?: string
    changeViewFunction: (view: ViewType) => void
    updateDataFlag: boolean
    setExportMenu: (items: string[]) => void
    viewMode?: string
    setViewMode?: (name: string) => void
}

const ExpensesByTosView = ({ contractId, filterStartDate, filterEndDate, changeViewFunction, updateDataFlag, setExportMenu, viewMode, setViewMode }: P) => {
    const triggerSnackbarError = (message: string) => {
        snackbar.show({ severity: 'error', text: message })
    }

    return (
        <Tile.Container style={{ maxHeight: '600px' }}>
            <Tile.Row flex={1} spacing={2} style={{ height: '100%' }}>
                <Tile.Column>
                    <TotalExpenseByTosSection
                        contractId={contractId}
                        title='Total Expense by Type of Services (TOS)'
                        subtitle='March'
                        startDate={filterStartDate}
                        endDate={filterEndDate}
                        icon='close'
                        changeViewFunction={changeViewFunction}
                        triggerSnackbarError={triggerSnackbarError}
                        updateDataFlag={updateDataFlag}
                        viewMode={viewMode}
                        setViewMode={setViewMode}
                        setExportMenu={setExportMenu}
                    />
                </Tile.Column>
                <Tile.Column>
                    <ExpenseByTosSection
                        contractId={contractId}
                        title='Expenses By Type Of Service'
                        subtitle='March'
                        startDate={filterStartDate}
                        endDate={filterEndDate}
                        triggerSnackbarError={triggerSnackbarError}
                        updateDataFlag={updateDataFlag}
                        viewMode={viewMode}
                    />
                </Tile.Column>
            </Tile.Row>
        </Tile.Container>
    )
}
export default ExpensesByTosView
